import { User } from "../types/User";
import { API_URL } from "../utils";

export default async (): Promise<User> => {
	const headers = new Headers();

	const result: User = await (await fetch(`${API_URL}/userProfile`, {
		credentials: 'include'
	})).json();

	return result;
}
